import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { ENVIROMENTS } from 'lib/constants'

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID

export const useTrackEvents = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== ENVIROMENTS.PRODUCTION) {
      return
    }

    if (!GA_MEASUREMENT_ID || typeof GA_MEASUREMENT_ID !== 'string') {
      return
    }

    ReactGA.initialize(GA_MEASUREMENT_ID)
    ReactGA.send('pageview')
  }, [])
}
